import React from 'react';
import PropTypes from 'prop-types';
import { EditorState, convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import get from 'lodash/get';
import truncHtml from 'trunc-html';

const PreviewText = ({ text }) => (
  <span className='rich-editor-preview' dangerouslySetInnerHTML={{ __html: text }} />
);

const getPreview = (content, defaultContent = '') => {
  if (!content.getPlainText()) {
    return defaultContent;
  }

  const text = content.getPlainText().length >= 1000
    ? truncHtml(convertToHTML(content), 1000).html
    : convertToHTML(content);

  return <PreviewText text={text} />;
};

export const RichEditorPreview = ({ content, defaultContent }) => {
  const editorState = get(content, 'blocks', null)
    ? EditorState.createWithContent(convertFromRaw(content))
    : EditorState.createEmpty();

  return getPreview(editorState.getCurrentContent(), defaultContent);
};

RichEditorPreview.propTypes = {
  content: PropTypes.object
};

export default React.memo(RichEditorPreview);
